import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { useIntlV2 as useIntl } from '@atlassian/jira-intl/src/v2/use-intl.tsx';
import { messages } from './messages.tsx';
import type { Props } from './types.tsx';

/**
 * AK does not have a shared component like this exposed as package at the moment.
 * so we basically duplicate the styles and added i18n into our own implementation.
 * If there's a ak implementation in the future. Welcome to replace it.
 */
export const ResizeButtonTooltip = ({ isLeftSidebarCollapsed, children }: Props) => {
	const intl = useIntl();
	const text = isLeftSidebarCollapsed
		? intl.formatMessage(messages.expand)
		: intl.formatMessage(messages.collapse);

	return (
		<Tooltip
			content={<TooltipNode text={text} char="[" />}
			hideTooltipOnClick
			position="right"
			testId="page-container-v2.common.ui.sidebar.resize-button-tooltip.tooltip"
		>
			{children}
		</Tooltip>
	);
};

export default ResizeButtonTooltip;

export const TooltipNode = ({ text, char }: { text: string; char: string }) => (
	<TooltipWrapper>
		<span>{text}</span>
		<ShortcutWrapper>{char}</ShortcutWrapper>
	</TooltipWrapper>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TooltipWrapper = styled.div({
	alignItems: 'baseline',
	display: 'flex',
	paddingBottom: token('space.025'),
	paddingTop: token('space.025'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ShortcutWrapper = styled.div({
	backgroundColor: token('color.background.neutral.bold.hovered'),
	borderRadius: '2px',
	marginLeft: token('space.050'),
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	paddingTop: '1px',
	paddingRight: token('space.100'),
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	paddingBottom: '1px',
	paddingLeft: token('space.100'),
});
